import { NgFor, NgIf, NgSwitch, NgSwitchCase, NgSwitchDefault, TitleCasePipe } from '@angular/common';
import { Component, Inject, OnInit, inject } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef
} from '@angular/material/dialog';
import { ButtonModule, DatePickerModule, DropdownModule, FormModule, GridModule, SharedModule } from '@coreui/angular-pro';

export interface FormModalData {
  controls: FormModalControl[]
  title?: string
}

export interface FormModalControl {
  key: string
  control: FormControl,
  label: string
  inputType: InputType
  options?: { id: number, name: string }[]
  placeholder?: string
}

export type InputType = 'date' | 'text' | 'select'

@Component({
  selector: 'app-form-modal',
  standalone: true,
  imports: [
    NgIf,
    NgSwitch,
    NgSwitchCase,
    NgSwitchDefault,
    NgFor,
    TitleCasePipe,
    MatDialogModule,
    ButtonModule,
    ReactiveFormsModule,
    GridModule,
    DatePickerModule,
    DropdownModule,
    SharedModule,
    FormModule,
  ],
  templateUrl: './form-modal.component.html',
  styleUrls: ['./form-modal.component.scss']
})
export class FormModalComponent implements OnInit {
  #fb = inject(FormBuilder)

  constructor(
    public dialogRef: MatDialogRef<FormModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: FormModalData,
  ) { }

  form?: FormGroup

  ngOnInit(): void {
    this.form = this.#fb.group(this.data.controls
      .reduce((acc, curr) => Object.assign(acc, { [curr.key]: curr.control }), {})
    )
  }

  getCtrl(key: string): AbstractControl | null {
    return this.form!.get(key);
  }

  close(send: boolean) {
    this.dialogRef.close(send ? this.form?.value : null)
  }
}
